// extracted by mini-css-extract-plugin
export default {"container":"FeedbackLoadingView_container__uI8a-","message":"FeedbackLoadingView_message__R2QKu","likeAnimation":"FeedbackLoadingView_likeAnimation__JKQ0p"};